Revolution.Module.extend({
    NAME: "mde.sliders", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)
    slider2ColumnsIsInit : false,
    sliders2Columns : [],
    slider3ColumnsIsInit : false,
    sliders3Columns : [],
    slider4ColumnsIsInit : false,
    sliders4Columns : [],

    initialize: function ($) {
        // appelé aussitôt la page chargée

        _.bindAll(this, "onWindowResize", "initSlider3Columns", "initOrDestroySlidersColumns");

        //events

        this.initSliders();

        this.initOrDestroySlidersColumns();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        this.initOrDestroySlidersColumns();
    },

    initSlider2Columns : function () {
        $('.js-slider-2-columns').each(_.bind(function (index, elem) {
            var slider2cols = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 15,
                // autoHeight: true,
                slideToClickedSlide: false,
                breakpoints: {
                    767: {
                        slidesPerView: 2
                    }
                }
            });

            this.sliders2Columns.push(slider2cols);
        }, this));
    },

    initSlider3Columns : function () {
        $('.js-slider-3-columns').each(_.bind(function (index, elem) {
            var slider3cols = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 15,
                slideToClickedSlide: false,
                breakpoints: {
                    767: {
                        slidesPerView: 2
                    },
                    1023: {
                        slidesPerView: 3
                    },
                }
            });

            this.sliders3Columns.push(slider3cols);
        }, this));
    },

    initSlider4Columns : function () {
        $('.js-slider-4-columns').each(_.bind(function (index, elem) {
            var slider4cols = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 15,
                slideToClickedSlide: false,
                breakpoints: {
                    767: {
                        slidesPerView: 2
                    },
                    1023: {
                        slidesPerView: 3
                    },
                }
            });

            this.sliders4Columns.push(slider4cols);
        }, this));
    },

	initOrDestroySlidersColumns : function () {
        if($('.js-slider-2-columns').length) {
            if ($(window).width() < 1024) {
                if (!this.slider2ColumnsIsInit) {
                    this.initSlider2Columns();
                    this.slider2ColumnsIsInit = true;

                }
            } else {
                if (this.slider2ColumnsIsInit) {
                    $.each(this.sliders2Columns, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliders2Columns = [];
                    this.slider2ColumnsIsInit = false;
                }
            }

            $('.js-slider-2-columns').attr('data-init-swiper', this.slider2ColumnsIsInit.toString());
            $.fn.matchHeight._apply($('.js-slider-2-columns').find('.article-content, .agenda-content'));
            $.fn.matchHeight._apply($('.js-slider-2-columns').find('.mea-content'));
            $.fn.matchHeight._apply($('.js-slider-2-columns').find('.agenda-top'));
        }

        if($('.js-slider-3-columns').length) {
            if ($(window).width() < 1024) {
                if (!this.slider3ColumnsIsInit) {
                    this.initSlider3Columns();
                    this.slider3ColumnsIsInit = true;

                }
            } else {
                if (this.slider3ColumnsIsInit) {
                    $.each(this.sliders3Columns, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliders3Columns = [];
                    this.slider3ColumnsIsInit = false;
                }
            }

            $('.js-slider-3-columns').attr('data-init-swiper', this.slider3ColumnsIsInit.toString());
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.article-content, .agenda-content'));
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.mea-content'));
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.agenda-top'));
        }

        if($('.js-slider-4-columns').length) {
            if ($(window).width() < 1280) {
                if (!this.slider4ColumnsIsInit) {
                    this.initSlider4Columns();
                    this.slider4ColumnsIsInit = true;

                }
            } else {
                if (this.slider4ColumnsIsInit) {
                    $.each(this.sliders4Columns, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliders4Columns = [];
                    this.slider4ColumnsIsInit = false;
                }
            }

            $('.js-slider-4-columns').attr('data-init-swiper', this.slider4ColumnsIsInit.toString());
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.article-content, .agenda-content'));
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.mea-content'));
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.agenda-top'));
        }
    },

    initSliders: function () {
        $('.js-slider-carousel').each(function (index, elem) {
            var is_quote = $(elem).hasClass('carousel-quote');
            var spaceBetween = is_quote ? 35 : 25;
            var items = $(elem).data('items') === undefined ? 3 : $(elem).data('items');
            var loop = !$(elem).hasClass('no-slide');
            if (window.innerWidth < 1000) {
              is_quote = false;
            }

            var swiperCarousel = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: items,
                spaceBetween: spaceBetween,
                centeredSlides: items !== 2,
                loop: loop,
                initialSlide: ((!loop && items === 3) || is_quote) ? 1 : 0,

                breakpoints: {
                    1024: {
                        slidesPerView: items,
                        spaceBetween: spaceBetween,
                    },
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                    }
                },

                navigation: {
                    nextEl: $(elem).find('.swiper-button-next'),
                    prevEl: $(elem).find('.swiper-button-prev'),
                },

                on: {
                    slideChange: function () {
                        $(swiperCarousel.slides[swiperCarousel.previousIndex]).removeClass('bigger');
                        $(swiperCarousel.slides[swiperCarousel.previousIndex]).removeClass('-transition');

                        $(swiperCarousel.slides[swiperCarousel.activeIndex]).addClass('bigger');
                        $(swiperCarousel.slides[swiperCarousel.activeIndex]).addClass('-transition');
                    }
                }
            });

            setTimeout(function () {
                $.fn.matchHeight._apply($(elem).find('.article-content'));
                $.fn.matchHeight._apply($(elem).find('.agenda-top'))
                $.fn.matchHeight._apply($(elem).find('blockquote p'))
            }, 800);
            setTimeout(function () {
                $(elem).find('.swiper-slide-active').addClass('bigger');
            }, 1000);
        });

        $('.js-slider-images').each(function (index, elem) {
            var swiperImages = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                updateOnImagesReady: true,
                pagination: {
                    el: $(elem).find('.swiper-pagination'),
                    type: 'fraction',
                },
                navigation: {
                    nextEl: $(elem).find('.swiper-button-next'),
                    prevEl: $(elem).find('.swiper-button-prev'),
                },
                on: {
                    imagesReady: function () {
                        setTimeout(_.bind(function () {
                            $(this.el).find('[class*="swiper-button"]').css('top', $(this.el).find('.swiper-slide-active img').height() + 'px');
                        }, this), 200);
                    },
                    resize: function () {
                        $(this.el).find('[class*="swiper-button"]').css('top', $(this.el).find('.swiper-slide-active img').height() + 'px');
                    },
                }
            });
        });

        $('.js-slider-frise').each(function (index, elem) {
            var swiperFrise = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 12,
                centeredSlides: false,
                loop: false,
                navigation: {
                    nextEl: $(elem).prev('.bk-timeline-top__wrapper').find('.swiper-button-next'),
                    prevEl: $(elem).prev('.bk-timeline-top__wrapper').find('.swiper-button-prev'),
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 36,
                    },
                    768: {
                        spaceBetween: 24,
                    },
                    480: {
                        slidesPerView: 2,
                    },
                },
                // on: {
                //     resize: function () {
                //         setTimeout( function() {
                //             swiperFrise.updateSize();
                //         },1000)
                //     },
                // }
            });
        });
    }
});
